'use strict';

const _ = require('underscore');
const DocumentList = require('bunsen/models/DocumentList');
const ListingDocumentList = module.exports = DocumentList.extend();
const PublicationType = require('bunsen/models/inventory/PublicationType');
const Listing = require('bunsen/models/inventory/Listing');
const endpoints = require('dibs-endpoints');
const defaultsDeep = require('lodash.defaultsdeep');

// NOTE* for jewelry items, regardless of seller vertical, COSTUME is fashion listing, FINE is jewelry listing
const getMarketplacePublicationTypeName = function (item) {
    let group;
    let jewelryType;
    if (item.isArt()) {
        group = PublicationType.MARKETPLACE_ART;
    } else if (item.isFurniture()) {
        group = PublicationType.MARKETPLACE_FURNITURE;
    } else if (item.isJewelry()) {
        jewelryType = item.get('classification.type');
        group = (jewelryType === 'COSTUME') ? PublicationType.MARKETPLACE_FASHION : PublicationType.MARKETPLACE_JEWELRY;
    } else if (item.isFashion()) {
        group = PublicationType.MARKETPLACE_FASHION;
    } else {
        throw new Error('Item vertical not defined');
    }
    return group;
};

// NOTE* regards COSTUME and FINE same as marketplace.
const getFeaturedPublicationTypeName = function (item) {
    let group;
    let jewelryType;
    if (item.isArt()) {
        group = PublicationType.FEATURED_ART;
    } else if (item.isFurniture()) {
        group = PublicationType.FEATURED_FURNITURE;
    } else if (item.isJewelry()) {
        jewelryType = item.get('classification.type');
        group = (jewelryType === 'COSTUME') ? PublicationType.FEATURED_FASHION : PublicationType.FEATURED_JEWELRY;
    } else if (item.isFashion()) {
        group = PublicationType.FEATURED_FASHION;
    } else {
        throw new Error('Item vertical not defined');
    }
    return group;
};

/**
 * determine the type of storefront listing to add for a given item.
 * NOTE : the storefront publication and listing types are determined by the seller's vertical not the items
 * which is especially relevant in the case of fashion-jewelry.
 * @param item
 * @returns {*}
 */
const getStorefrontPublicationTypeName = function (item) {
    const seller = item.get('seller');
    let group;
    if (seller.isArtSeller()) {
        group = PublicationType.DEALER_STOREFRONT_ART;
    } else if (seller.isFurnitureSeller()) {
        group = PublicationType.DEALER_STOREFRONT_FURNITURE;
    } else if (seller.isJewelrySeller()) {
        group = PublicationType.DEALER_STOREFRONT_JEWELRY;
    } else if (seller.isFashionSeller()) {
        group = PublicationType.DEALER_STOREFRONT_FASHION;
    } else {
        throw new Error('Seller vertical not defined');
    }
    return group;
};
const addListing = function (typeGetter) {
    return function (types) {
        const item = this.parents[0];
        const typeName = typeGetter(item);
        const type = types.getType(typeName);
        const listing = new Listing({
            type: type,
            item: {
                id: item.get('id')
            }
        });
        this.add(listing);
        return listing;
    };
};

const filterListing = function (...filters) {
    return function (options) {
        options = options || {};
        const listings = this.filter(function (listing) {
            return filters.reduce((isFiltered, next) => {
                let bool = listing[next]();
                if (options.not) {
                    bool = !bool;
                }
                return isFiltered || bool;
            }, false);
        });
        return new ListingDocumentList({ documents: listings });
    };
};

_.extend(ListingDocumentList.prototype, {
    model: Listing,
    url: function () {
        const item = this.parents[0];
        return endpoints.itemListings(item.id);
    },
    save: function (attrs, options) {
        const item = this.parents[0];
        options = defaultsDeep(options || {}, {
            queries: {
                indexMode: 'sync'
            },
            patch: true
        });
        return ListingDocumentList.__super__.save.call(
            this,
            {
                id: item.id,
                apiType: 'item',
                listings: {
                    apiType: 'documentList',
                    documents: this.toJSON().documents
                }
            },
            options
        );
    },
    addFeaturedListing: addListing(getFeaturedPublicationTypeName),
    addMarketplaceListing: addListing(getMarketplacePublicationTypeName),
    addStorefrontListing: addListing(getStorefrontPublicationTypeName),
    addWeeklySaleListing: addListing(() => PublicationType.SATURDAY_SALE),
    filterMarketplace: filterListing('isMarketplace'),
    filterFeatured: filterListing('isFeatured'),
    filterStorefront: filterListing('isStorefront'),
    filterNew: filterListing('isNewStatus'),
    filterComplete: filterListing('isCompleteStatus'),
    filterPublished: filterListing('isPublishedStatus'),
    filterQueued: filterListing('isQueuedStatus'),
    filterUnavailable: filterListing('isUnavailableStatus'),
    filterDeleted: filterListing('isDeletedStatus'),
    filterNotDeleted: filterListing('isNotDeletedStatus'),
    filterUnsaved: filterListing('isNew'),
    filterSale: filterListing('isSale'),
    filterCanAttachListings: filterListing('isMarketplace', 'isFeatured', 'isStorefront'),
    getTypeMetadata(type) {
        const groupedListingStatuses = this.get('metadata.groupedListingStatuses');
        const typeMetadata = groupedListingStatuses && groupedListingStatuses[type];
        return typeMetadata ? (Array.isArray(typeMetadata) ? typeMetadata : [typeMetadata]) : [];
    },
    hasPublishedListing() {
        let hasPublishedListings = false;
        this.eachType((type, statuses) => {
            if (statuses.indexOf(Listing.STATUS.PUBLISHED) >= 0) {
                hasPublishedListings = true;
            }
        });
        return hasPublishedListings || this.filterPublished().any();
    },
    /**
     * synonym to is listed (opposite of unlisted or not listed).  Checks metadata and listings
     * @return {Boolean}
     */
    hasListings() {
        let hasListings = false;
        this.eachType((type, statuses) => {
            if (statuses.indexOf(Listing.STATUS.DELETED) === -1) {
                hasListings = true;
            }
        });
        return hasListings || this.filterDeleted({ not: true }).any();
    },
    isRepost() {
        return this.getMetadata('itemRepost') === true;
    },
    eachType(fn) {
        let type;
        for (type in Listing.TYPE) {
            if (Listing.TYPE.hasOwnProperty(type)) {
                fn.call(this, type, this.getTypeMetadata(Listing.TYPE[type]));
            }
        }
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/ListingDocumentList.es.js